var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "pt-05 pb-05" }, [
    _vm.group !== null && this.section !== "group"
      ? _c("div", [
          _c("a", { attrs: { href: "/group/" + _vm.group.slug } }, [
            _c("div", { staticClass: "card text-white mb-0 border-0" }, [
              _c("img", {
                staticClass: "card-img img-fluid",
                staticStyle: { height: "3rem" },
                attrs: {
                  src:
                    _vm.group.group_cover == null
                      ? "/images/cover.jpg"
                      : _vm.group.group_cover.url,
                },
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "card-img-overlay overflow-hidden overlay-dark d-flex align-items-center pt-05 pb-05 pl-1 pr-05",
                },
                [
                  _c(
                    "p",
                    {
                      staticClass: "text-white mb-0",
                      staticStyle: { "line-height": "1rem" },
                    },
                    [
                      _c("strong", [
                        _vm._v(_vm._s(_vm.__("globals.posted_in")) + " "),
                      ]),
                      _vm._v(
                        "\n                        " + _vm._s(_vm.group.title)
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    { staticClass: "btn-sm btn-outline-white ml-auto" },
                    [
                      _vm._v(_vm._s(_vm.__("globals.view_group")) + " "),
                      _c("i", { staticClass: "feather icon-chevron-right" }),
                    ]
                  ),
                ]
              ),
            ]),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.supplier !== null && this.section !== "supplier"
      ? _c("div", [
          _c("a", { attrs: { href: "/supplier/" + _vm.supplier.slug } }, [
            _c("div", { staticClass: "card text-white mb-0 border-0" }, [
              _c("img", {
                staticClass: "card-img img-fluid",
                staticStyle: { height: "3rem" },
                attrs: {
                  src:
                    _vm.supplier.supplier_cover_image == null
                      ? "/images/cover.jpg"
                      : _vm.supplier.supplier_cover_image.url,
                },
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "card-img-overlay overflow-hidden overlay-dark d-flex align-items-center pt-05 pb-05 pl-1 pr-05",
                },
                [
                  _c(
                    "p",
                    {
                      staticClass: "text-white mb-0",
                      staticStyle: { "line-height": "1rem" },
                    },
                    [
                      _c("strong", [
                        _vm._v(_vm._s(_vm.__("globals.posted_in")) + " "),
                      ]),
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.supplier.title)
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    { staticClass: "btn-sm btn-outline-white ml-auto" },
                    [
                      _vm._v(_vm._s(_vm.__("globals.view_page")) + " "),
                      _c("i", { staticClass: "feather icon-chevron-right" }),
                    ]
                  ),
                ]
              ),
            ]),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }